<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import uploadFileplus from '../../../common/uploadFileplus/index.vue';
	import FileToSeeplus from '../../../common/FileToSeeplus/index.vue';
	import config from '../../../../../configHttp.js';
	import {
		manuscriptquery,
		manuscriptUploadFile,
		annexadd,
		queryAttachmentList,
		annexdelete,
		forShengcdg,
		submitAudit,
		manuscriptexport,
		manuscriptcancelAudit,
		manuscriptzfbc,
		manuscriptstartShenBao,
		manuscriptstartCorrections,
		refreshReport,
		loadPaymentTask,
		downloadPdf,
		queryCompanyShuibDict,
		modifyMessage,
		queryDialog,
    updateTheFilingStatus
	} from '../../../../api/Draftgeneration.js';
	import {
		getShuizList,templateExquery
	} from '../../../../api/bbmb.js';
	import SalesTaxReport from '../../Applicationdraft/Draftgeneration/SalesTaxReport/index.vue';
	import AssetsAndLiabilitiesY from '../../Applicationdraft/Draftgeneration/AssetsAndLiabilitiesY/index.vue';
	import AssetsAndLiabilities from '../../Applicationdraft/Draftgeneration/AssetsAndLiabilities/index.vue';
	import SmallScaleVAT from '../../Applicationdraft/Draftgeneration/SmallScaleVAT/index.vue';
	import valueAddedTax from '../../Applicationdraft/Draftgeneration/valueAddedTax/index.vue';
	import corporateIncomeTax from '../../Applicationdraft/Draftgeneration/corporateIncomeTax/index.vue';
	import corporateIncomeTax_V2 from '../../Applicationdraft/Draftgeneration/corporateIncomeTax_V2/index.vue';
	import ConsolidatedStatement from '../../Applicationdraft/Draftgeneration/ConsolidatedStatement/index.vue';
	import TaxableService from '../../Applicationdraft/Draftgeneration/TaxableService/index.vue';
	import GeneralReturn from '../../Applicationdraft/Draftgeneration/GeneralReturn/index.vue';
	import GeneralReturnF from '../../Applicationdraft/Draftgeneration/GeneralReturnF/index.vue';
	import DisabilityPayment from '../../Applicationdraft/Draftgeneration/DisabilityPayment/index.vue';
	import BalanceSheet from '../../Applicationdraft/Draftgeneration/BalanceSheet/index.vue';
	import AdditionalTax from '../../Applicationdraft/Draftgeneration/AdditionalTax/index.vue';
	import diguizi from '../../ConfigurationCenter/zzsz/ContentsSetting/diguizj/index.vue';
    import {exportTaxReportExcel} from '../../../../api/workManuscript.js'
  import {queryExportIncomeDifference} from "../../../../api/ckywqk";
  import ExportIncomeDifference from "../../../common/SalesTaxReportbox/ExportIncomeDifference/index.vue";
	export default {
		name: 'sbjk',
		components: {
      ExportIncomeDifference,
			uploadFileplus,
			FileToSeeplus,
			SalesTaxReport,
			AssetsAndLiabilitiesY,
			AssetsAndLiabilities,
			SmallScaleVAT,
			valueAddedTax,
			corporateIncomeTax,
      corporateIncomeTax_V2,
			ConsolidatedStatement,
			TaxableService,
			GeneralReturn,
			DisabilityPayment,
			BalanceSheet,
			diguizi,
			AdditionalTax
		},
		data: function() {
			return {
				permissions:JSON.parse(localStorage.getItem('resources')),
				zfyy: '',
				datalist: {},
				tablekey: 0,
				overlength: 0,
				searchdata: getdata().searchdata,
				searchlist: getdata().searchlist,
				searchdiag: false,
				outlist: [],
				upfile: {},
				headData: getdata().headData,
				tableData: getdata().tableData,
				suosq: this.$getdefultMonth(),
				shaidiag: false,
				formlist: getdata().formlist,
				formdata: {
					type: '',
					name: '',
					description: ''
				},
				showbox: {
					yhs: false,
					zzs: false,
					cwbbybqyyzx: false,
					cwbbybqywzx: false,
					cwbbxqy: false,
					zzsxgm: false,
					qysdsA: false,
          qysdsA_V2: false,
					cztds: false,
					fcs: false,
					cwbbkjzd: false,
					cbj: false,
					whsy: false,
					tysl: false,
					tygh: false,
					tylj: false,
					hjbhs: false,
					ty: false,
					noty: false,
					xfs: false,
				},
				gengzbox: {
					zzs: false,
					zzsxgm: false,
					// cwbbybqyyzx: false,
					// cwbbybqywzx: false,
					// cwbbxqy: false,
					qysdsA: false,
					whsy: false,
					xfs: false,
				},
				detailtype: '',
				Saleparams: {},
				seeNow: false,
				updiag: false,
				toseediag: false,
				headseeData: getdata().headseeData,
				tableseeData: getdata().tableseeData,
				fxdetail: false,
				headDatafx: getdata().headDatafx,
				tableDatafx: [],
				zfdiag: false,
				pagination: getdata().pagination,
				paginationfile: getdata().paginationfile,
				checked: '',
				showmodifyMessage: false,
				modifyMessageTitle: '添加更正说明',
				modifyMessageCentent: '',
				modifyMessageId: '',
				isShow: false,
				itemValue: {},
				widthxz: 800,
				heightxz: 800,
				rotate: 0,
				mintext: '查看',
				assist: false,
				asslist: [],
				assvalue: [],
				tableDatabody: [],

                generateSummaryReportFlag: false,
                generateSummaryReportDate:[],
        // 模板列表
        templateDataMap: {},
        // 底稿生成、申报缴款页面是否显示 仅展示零申报企业条件
        lsbqyEnable: config.lsbqyEnable,
        exportIncomeDifferenceDiag: false,
        exportIncomeDifferenceParams: {},
			};
		},
		mounted() {
		},
		created() {
			this.manuscriptquery();
      templateExquery({current: 1, size: 50}).then(res => {
        this.templateDataMap = res.data.data.records.reduce((map, item) => {
          map[item.id] = item;
          return map;
        }, {});
      })
		},
		activated() {
			this.manuscriptquery();
		},
		methods: {
			downloadTaxPaymentCertificate(e) {
				if (e.taxPaymentUrl != '' && e.taxPaymentUrl != null) {
					let params = {
						downUrl: config.baseURL + '/manuscript/downloadTaxPaymentCertificate',
						typeObj: {
							toForm: true,
							fileType: 'zip',
							// failUrl: this.$winURl,
							headers: {
								Authorization: localStorage.getItem('nstoken')
							}
						},
						params: {
							reportId: e.id,
						}
					};
					this.$downloadcommon(params);
				}
			},
			closediag() {
				this.heightxz = 800;
				this.widthxz = 800;
				this.isShow = false
			},
			Download() {
				const filename = this.itemValue.errorImageUrl;
				const link = document.createElement('a');
				link.href = this.itemValue.errorImageUrl;
				link.download = filename;
				link.click();
			},
			scaling(i) {
				if (i) {
					this.heightxz = this.heightxz - 50;
					this.widthxz = this.widthxz - 50;
				} else {
					this.heightxz = this.heightxz + 50;
					this.widthxz = this.widthxz + 50;
				}
			},
			rotateImg() {
				if (this.rotate >= 270) {
					this.rotate = 0;
				} else {
					this.rotate = this.rotate + 90;
				}
				if (this.rotate / 90 % 2 == 1) {
					this.widthxz = document.getElementById('cwctImg').offsetHeight
				} else {
					this.widthxz = this.heightxz
				}
			},
			errorImage(e) {
				if (e.errorImageUrl) {
					this.isShow = true
					this.itemValue = e
				}
			},
			geOoverLength(e) {
				this.overlength = e;
			},
			dowPdf(e) {
				if (e.pdfUrl != '' && e.pdfUrl != null) {
					let params = {
						downUrl: config.baseURL + '/manuscript/downloadPdf',
						typeObj: {
							toForm: true,
							fileType: 'zip',
							failUrl: this.$winURl,
							headers: {
								Authorization: localStorage.getItem('nstoken')
							}
						},
						params: {
							id: e.id,
						}
					};
					this.$downloadcommon(params);
				}
			},
			manuscriptcancelAudit(arr) {
				let params = [arr.id];
				manuscriptcancelAudit(params).then(res => {
					if (res.data.code == 1) {
						this.manuscriptquery();
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			forback(e) {
				Object.keys(this.showbox).map(key => (this.showbox[key] = false));
				this.manuscriptquery();
			},
			fortosee(taxval) {
				console.log(taxval)
				this.detailtype = 'tosee';
				this.seeNow = true;
				this.Saleparams = taxval;
        let version = this.templateDataMap[taxval.templateId].cank1;
        if (!version) {
          version = "";
        }
        this.showbox[taxval.sbbm + version] = true;
			},
			//文件查看
			sizechangefile() {
				this.paginationfile.pageSize = e;
			},
			currentChangefile() {
				this.paginationfile.pageNum = e;
			},
			forseefile(e) {
				this.chooseid = e.id;
				this.choosecompanyCode = e.companyCode;
				this.chooseshuibId = e.shuibId;
				let params = {
					id: e.id
				};
				params.current = this.paginationfile.pageNum;
				params.size = this.paginationfile.pageSize;
				queryAttachmentList(params).then(res => {
					this.tableseeData = res.data.data.records;
					this.paginationfile.total = res.data.data.total;
					this.toseediag = true;
				});
			},
			closetoseediag() {
				this.toseediag = false;
			},
			fordownloadFile(e) {
				let url = this.$winURl + e.fileUrl
				window.open(url)
				// let params = {
				// 	downUrl: config.baseURL + e.fileUrl,
				// 	typeObj: {
				// 		toForm: false,
				// 		fileType: e.fileName.split('.')[1],
				// 		fileName: e.fileName.split('.')[0],
				// 		failUrl: this.$winURl,

				// 	},
				// 	params: {
				// 		attIds: [e.id],
				// 		companyCode: this.choosecompanyCode,
				// 		shuibId: this.chooseshuibId
				// 	}
				// };
				// this.$downloadcommon(params);
			},
			fordownloadpl(e) {
				if (this.$emptyandnull(e)) {
					this.$message.error('请选择要下载的数据');
					return false;
				}
				let params = {
					downUrl: config.baseURL + 'manuscript/annex/downloads',
					typeObj: {
						toForm: false,
						fileType: 'zip',
						failUrl: this.$winURl,

					},
					params: {
						attIds: e.map(item => item.id),
						companyCode: this.choosecompanyCode,
						shuibId: this.chooseshuibId
					}
				};
				this.$downloadcommon(params);
			},
			fodeleteFile(e) {
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						annexdelete([e.id]).then(res => {
							if (res.data.code == 1) {
								this.$message.success('删除成功');
								this.paginationfile.paginationkey++;
								this.paginationfile.pageNum = '1';
								this.forseefile({
									id: this.chooseid,
									companyCode: this.choosecompanyCode,
									shuibId: this.chooseshuibId
								});
								this.manuscriptquery();
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				});
			},
			choosechange(e) {
				this.tableData.forEach(item => {
					item.checked = e;
				});
				let newarr = JSON.parse(JSON.stringify(this.tableData));
				this.tableData = newarr;
			},
			jksh(e) {
				this.$showConfirm({
					message: '是否确认?',
					title: '缴款申请'
				}).then(res => {
					if (res == 'confirm') {
						let params = {
							id: e
						};
						loadPaymentTask(params).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg);
								this.manuscriptquery();
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				});
			},
			sxlist() {
				let exportIds = [];
				this.tableData.map(item => {
					if (item.checked) {
						exportIds.push(item.id);
					}
				});
				let params = JSON.parse(JSON.stringify(this.searchdata));
				params.czsjks = params.czsjjs[0];
				params.czsjjs = params.czsjjs[1];
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.queryType = 2;
				params.suosq = this.suosq;
				params.exportIds = exportIds;
				refreshReport(params).then(res => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.manuscriptquery();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			declare() {
				let arr = [];
				let issbsb = []
				this.tableData.map(item => {
					if (item.checked == true) {
						arr.push({
							id: item.id,
							companyNo: item.companyNo,
							sbbm: item.sbbm
						});
						if (item.status == '7') {
							issbsb.push(item)
						}
					}
				});
				if (issbsb.length > 0) {
					this.$message.error('申报失败的不允许批量申报！');
					return
				}
				if (arr.length != 0) {
					manuscriptstartShenBao(arr).then(res => {
						if (res.data.code == 1) {
							this.$message.success(res.data.msg);
							this.manuscriptquery();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					this.$message.error('请选择你先勾选');
				}
			},
			corrections() {
				let selectval = this.tableData.filter(item => item.checked);
				if (selectval.length > 1) {
					this.$message.error('只能选择一条数据进行申报更正');
					return;
				} else if (selectval.length != 1) {
					this.$message.info('请选择一条数据');
					return;
				}
				let status = selectval[0].status;
				if(status !='6' && status !='9' && status !='23') {
					this.$message.info('只有申报成功、缴款成功、申报更正失败的数据才能申报更正');
					return;
				}
				let sbbm =  selectval[0].sbbm;
				if(sbbm != 'cwbbybqyyzx' && sbbm != 'cwbbybqywzx' && sbbm != 'cwbbxqy' && sbbm != 'cwbbkjzd'  && sbbm != 'cwbbfylzzkjzd') {
					this.$message.info('只支持财务报表进行申报更正');
					return;
				}
				this.$showConfirm({
					message: '是否确认?',
					title: '申报更正'
				}).then(res => {
					if (res == 'confirm') {
						let taxval = selectval[0];
						// this.detailtype = 'tosee';
						// this.seeNow = true;
						// this.Saleparams = taxval;
						// this.gengzbox[taxval.sbbm] = true;

						let params = {
							id: taxval.id,
							companyNo: taxval.companyNo,
							sbbm: taxval.sbbm
						};
						manuscriptstartCorrections(params).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg);
								this.manuscriptquery();
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				});
			},
			forjkpzdownload(val) {
				if (val.jkScreenUrl != '' && val.jkScreenUrl != null) {
				let param = {
					id: val.id
				};
				let params = {
					downUrl: config.baseURL + 'manuscript/downloadJkScreenUrl',
					typeObj: {
						toForm: true,
						fileType: 'png',
						failUrl: this.$winURl,

					},
					params: param
				};
				this.$downloadcommon(params);
			}
			},
			fordeclare(val) {
				this.$showConfirm({
					message: '是否确认?',
					title: '一键申报'
				}).then(res => {
					if (res == 'confirm') {
						if (val.status == 7) {
              if (val.sbbm=='qysdsA') {
                queryExportIncomeDifference({reportId: val.id}).then((res) => {
                  if (res.data.code === 1) {
                    if (res.data.data.id) {
                      this.exportIncomeDifferenceParams.sbbm = val.sbbm;
                      this.exportIncomeDifferenceParams.id = val.id;
                      this.exportIncomeDifferenceParams.companyNo = val.companyNo;
                      this.exportIncomeDifferenceDiag = true;
                    } else {
                      this.queryDialog(val);
                    }
                  } else {
                    this.$message.error(res.data.msg);
                  }
                });
              } else {
                this.queryDialog(val);
              }
						} else {
							manuscriptstartShenBao([{
								id: val.id,
								companyNo: val.companyNo,
								sbbm: val.sbbm
							}]).then(res => {
								if (res.data.code == 1) {
									this.$message.success(res.data.msg);
									this.manuscriptquery();
								} else {
									this.$message.error(res.data.msg);
								}
							});
						}
					}
				});
			},
      // 出口收入差异情况表
      closeExportIncomeDifferenceDiag(e) {
        this.exportIncomeDifferenceDiag = false;
      },
      confirmExportIncomeDifference(e) {
        this.exportIncomeDifferenceDiag = false;
        this.queryDialog(this.exportIncomeDifferenceParams);
      },
      queryDialog(val) {
        queryDialog({
          id: val.id
        }).then(res => {
          if (res.data.code == 1) {
            if (res.data.data == null) {
              manuscriptstartShenBao([{
                id: val.id,
                companyNo: val.companyNo,
                sbbm: val.sbbm
              }]).then(res => {
                if (res.data.code == 1) {
                  this.$message.success(res.data.msg);
                  this.manuscriptquery();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
            } else {
              this.tableDatabody = [{
                id: val.id,
                companyNo: val.companyNo,
                sbbm: val.sbbm
              }]
              this.asslist = []
              this.asslist.push(JSON.parse(res.data.data.result));
              this.assist = true
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
      },
			nextpz() {
				this.assvalue = [];
				this.asslist.map((item) => {
					item.taxDialogOptionList.map((item1) => {
						if (item1.children.length != 0) {
							this.chanegs(item1);
						} else {
              if (item1.memoJson) {
                this.assvalue.push({
                  optionCode: item1.optionCode,
                  memoJson: item1.memoJson
                });
              } else if (item.checked === item1.optionCode) {
                this.assvalue.push({
                  optionCode: item1.optionCode
                });
              }
						}
					});
				});
				if (this.assvalue.length > 0 && (!this.assvalue[0].memoJson || this.assvalue[0].memoJson == "")) {
					this.$message.error("请输入原因！");
					return;
				}
				let params = {
					id: this.tableDatabody[0].id,
					companyNo: this.tableDatabody[0].companyNo,
					sbbm: this.tableDatabody[0].sbbm,
          optionCodeList: this.assvalue
				};
				manuscriptstartShenBao([params]).then(res => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.manuscriptquery();
						this.assist = false
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			chanegs(value) {
				for (let index = 0; index < value.children.length; index++) {
          if (!value.children[index].children || value.children[index].children.length == 0) {
            if (value.children[index].memoJson) {
              this.assvalue.push({
                optionCode: value.children[index].optionCode,
                memoJson: value.children[index].memoJson
              });
            } else if (value.checked === value.children[index].optionCode) {
              this.assvalue.push({
                optionCode: value.children[index].optionCode
              });
            }
          } else {
            this.chanegs(value.children[index]);
          }
				}
			},
			//作废申报
			manuscriptzfbcs() {
				let params = {
					companyNo: this.datalist.companyNo,
					sbbm: this.datalist.sbbm,
					id: this.datalist.id,
					errorMsg: this.zfyy
				};
				manuscriptzfbc(params).then(res => {
					if (res.data.code == 1) {
						this.zfdiag = false;
						this.manuscriptquery();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			manuscriptexport() {
				let exportIds = []
				this.tableData.map(item => {
					if (item.checked) {
						exportIds.push(item.id)
					}
				})
				let param = JSON.parse(JSON.stringify(this.searchdata));
				param.current = this.pagination.pageNum;
				param.size = this.pagination.pageSize;
				param.suosq = this.suosq;
				param.queryType = '2';
				if (exportIds.length > 0) {
					param.exportIds = exportIds
				}
				let params = {
					downUrl: config.baseURL + 'manuscript/manuscript/export',
					typeObj: {
						toForm: false,
						fileType: 'xlsx',
						failUrl: this.$winURl,

					},
					params: param
				};
				this.$downloadcommon(params);
			},
			forsubmit(e) {
				if (this.$emptyandnull(this.upfile.fileUrl)) {
					this.$message.error('请选择要上传的文件');
					return false;
				}
				let params = JSON.parse(JSON.stringify(this.formdata));
				params.fileName = this.upfile.fileName;
				params.fileUrl = this.upfile.fileUrl;
				// params.reportId = this.upfile.reportId
				params.id = this.upfile.reportId;
				params.type = '2';
				annexadd(params).then(res => {
					if (res.data.code == 1) {
						this.manuscriptquery();
						this.closeupdiag();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			getuploadparams(e) {
				manuscriptUploadFile({
					file: e.upfile
				}).then(res => {
					if (res.data.code == 1) {
						this.upfile.fileName = res.data.data.fileName;
						this.upfile.fileUrl = res.data.data.fileUrl;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			openUpfileplus(reportId) {
				Object.keys(this.formdata).map(key => (this.formdata[key] = ''));
				Object.keys(this.upfile).map(key => (this.upfile[key] = ''));
				this.upfile.reportId = reportId;
				this.updiag = true;
			},
			suosqchange() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.tablekey++;
				this.manuscriptquery();
			},
			manuscriptquery() {
				let params = JSON.parse(JSON.stringify(this.searchdata));
				params.czsjks = params.czsjjs[0];
				params.czsjjs = params.czsjjs[1];
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.queryType = 2;
				params.suosq = this.suosq;
				manuscriptquery(params).then(res => {
					this.getShuizList();
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
					this.tableData.forEach(item => {
						item.checked = false;
					});
					this.checked = false;
					let newarr = JSON.parse(JSON.stringify(this.tableData));
					this.tableData = newarr;
				});
			},
			getShuizList() {
				queryCompanyShuibDict().then(res => {
					this.searchlist.forEach(item => {
						if (item.prop == 'shuizId') {
							item.selectval = res.data.data.map(item => {
								return {
									label: item.reportName,
									value: item.id
								};
							});
						}
					});
					let newarr = JSON.parse(JSON.stringify(this.searchlist));
					this.searchlist = newarr;
				});
			},
			forzf(e) {
				this.zfdiag = true;
				this.zfyy = '';
				this.datalist = e;
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 0 || columnIndex == 1) {
					return {
						rowspan: row.span > 0 ? row.span : 0,
						colspan: row.span > 0 ? 1 : 0
					};
				} else {
					return [1, 1];
				}
			},
			submitSearch() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.manuscriptquery();
			},
			sizechange(e) {
				this.pagination.pageSize = e;
				this.manuscriptquery();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.manuscriptquery();
			},
			forUpdateSearch() {
				this.searchdiag = true;
			},
			closeSearch() {
				this.searchdiag = false;
			},
			saveChange(e) {
				this.searchdiag = false;
			},
			confirmfilter(e) {
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
			},
			closeshaidiag() {
				this.shaidiag = false;
			},
			closeupdiag() {
				this.updiag = false;
			},
			//更正说明
			addmodifymessage() {
				let selectval = this.tableData.filter(item => item.checked);
				if (selectval.length > 1) {
					this.$message.error('只能选择一条添加更正说明');
					return;
				} else if (selectval.length != 1) {
					this.$message.info('请选择一条数据');
					return;
				}
				let status = selectval[0].status;
				if ('6' != status && '9' != status) {
					this.$message.info('只有申报成功、缴款成功的数据才能添加更正说明');
					return;
				}
				//如果已有值，则换成编辑框
				if (!this.$emptyandnull(selectval[0].gengzsm)) {
					this.updatemodifymessage(selectval[0].id, selectval[0].gengzsm);
					return;
				}
				this.modifyMessageTitle = '添加更正说明';
				this.modifyMessageCentent = '';
				this.modifyMessageId = selectval[0].id;
				this.showmodifyMessage = true;
			},
			updatemodifymessage(id, message) {
				this.modifyMessageTitle = '修改更正说明';
				this.modifyMessageCentent = message;
				this.modifyMessageId = id;
				this.showmodifyMessage = true;
			},
			updateGengzsm() {
				if (this.$emptyandnull(this.modifyMessageCentent)) {
					this.$message.info('内容不能为空');
					return;
				}
				this.apiGengzsm(this.modifyMessageId, this.modifyMessageCentent);
			},
			deleteGengzsm() {
				this.apiGengzsm(this.modifyMessageId, '');
			},
			apiGengzsm(id, message) {
				let param = {
					id: id,
					message: message
				};
				modifyMessage(param).then(res => {
					if (res.data.code == 1) {
						this.manuscriptquery();
					} else {
						this.$message.error('操作失败');
					}
					this.showmodifyMessage = false;
				});
			},
            //生成汇总报表
            generateSummaryReport(){
                console.log("生成汇总报表.......")
                this.generateSummaryReportDate = [];
                this.generateSummaryReportFlag = true;
            },
            generateSummaryReportConfirm(){
                if (this.generateSummaryReportDate.length !== 2) {
                    this.$message.error("请选择时间范围！");
                    return;
                }
                // exportTaxReportExcel({period: this.generateSummaryReportDate.join(",")}).then(res=>{
                //     if (res.data.code === 0) {
                //         this.$message.error(res.data.msg);
                //     }
                //     this.generateSummaryReportFlag = false;
                // })
                let data = {period: this.generateSummaryReportDate.join(",")};
                let params = {
                    downUrl: config.baseURL + 'work-manuscript/exportTaxReportExcel',
                    typeObj: {
                        toForm: false,
                        fileName: '税款汇总表_' + this.suosq + "_" + this.$timestampToStr(new Date(), 'yyyyMMdd'),
                        fileType: 'xlsx'
                    },
                    params: data
                };
                this.$downloadcommon(params);
            },

            batchExportReportFile(){
                let exportIds = [];
                this.tableData.map(item => {
                    if (item.checked) {
                        exportIds.push(item.id);
                    }
                });
                let searchData = JSON.parse(JSON.stringify(this.searchdata));
                if (searchData.czsjjs[0]) {
                    searchData.czsjks = searchData.czsjjs[0];
                }
                if (searchData.czsjjs[1]) {
                    searchData.czsjjs = searchData.czsjjs[1];
                }
                searchData.current = this.pagination.pageNum;
                searchData.size = this.pagination.pageSize;
                searchData.queryType = 2;
                searchData.suosq = this.suosq;
                searchData.exportIds = exportIds;

                let params = {
                    downUrl: config.baseURL + 'manuscript/batchDownloadReportFile',
                    typeObj: {
                        toForm: false,
                        fileType: 'zip',
                        // failUrl: this.$winURl,
                        headers: {
                            Authorization: localStorage.getItem('nstoken'),
                        }
                    },
                    params: searchData,
                };
                this.$downloadcommon(params);
            },
      updateTheFilingStatus(){
        let ids = [];
        // 3、审核成功 5、申报中 6、申报成功 7、申报失败 9、缴款成功 10、缴款失败 11、缴款中, 12,申报作废中 22、申报更正中
        let shenbztArr = ["3", "5", "6", "7", "9", "10", "11", "12", "22"]
        let flag = false;
        this.tableData.map(item => {
          if (item.checked) {
            ids.push(item.id);
            if (!shenbztArr.includes(item.status)) {
              flag = true;
            }
          }
        });
        if (flag) {
          this.$message.error('有无法更新申报状态的数据');
          return
        }
        if (ids.length !== 0) {
          updateTheFilingStatus(ids).then(res => {
            if (res.data.code === 1) {
              this.$message.success(res.data.msg);
              this.manuscriptquery();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$message.error('请勾选数据');
        }
      },
      // 导出申报
      exportTheDeclaration() {
        let ids = [];
        // 仅支持印花税、房产税、环境保护税、财务报表-企业会计准则(一般企业已执行新准则)
        let sbbmArr = ["yhs", "fcs", "hjbhs", "cwbbybqyyzx"]
        let flag = false;
        this.tableData.map(item => {
          if (item.checked) {
            ids.push(item.id);
            if (!sbbmArr.includes(item.sbbm)) {
              flag = true;
            }
          }
        });
        if (flag) {
          this.$message.error('导出申报仅支持印花税、房产税、环境保护税、财务报表');
          return;
        }
        if (ids.length !== 0) {
          let params = {
            downUrl: config.baseURL + 'manuscript/exportTheDeclaration',
            typeObj: {
              toForm: false,
              fileType: '',
              failUrl: this.$winURl,
            },
            params: {ids: ids, suosq: this.suosq}
          };
          this.$downloadcommon(params);
        } else {
          this.$message.error('请勾选数据');
        }
      },
      jzslsbqyChange() {
        this.manuscriptquery();
      }
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>
